import axios from "axios";
import { CREATE_ADMINISTERED, FETCH_ADMINISTEREDS, UPDATE_ADMINISTEREDS, DELETE_ADMINISTEREDS,
  interceptor 
} from ".";
import store from "../store";
// import { BASE_URL } from "../utils/helper";

interceptor(axios, store);
export function createAdministered(adm) {
  return {
    type: CREATE_ADMINISTERED,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/medication/`, adm, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchAdministereds() {
  return {
    type: FETCH_ADMINISTEREDS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/medication/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function updateAdministereds(data) {
  return {
    type: UPDATE_ADMINISTEREDS,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/medication/${data.id}`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function deleteAdministereds(id) {
  return {
    type: DELETE_ADMINISTEREDS,
    payload: axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/core/medication/${id}`,{
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
